import {
  getCommentsReactionList,
  getDiscussionPostReactionList,
  getRepliesReactionList,
} from '@/actions/room';
import AvatarComponent from '@/components/common/avatar';
import { emojis } from '@/helpers/index';
import { Modal } from 'antd';
import classnames from 'classnames';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Nav, NavItem, NavLink, Spinner, TabContent, TabPane } from 'reactstrap';

const ReactionListView = (reactionData, id) =>
  reactionData[id]?.status === 'request' ? (
    <div className="d-flex justify-content-center align-items-center">
      <Spinner animation="border" className="mt-3" />
    </div>
  ) : (
    reactionData[id]?.data?.length !== 0 &&
    reactionData[id]?.data?.map((reactionUser, i) => (
      <div key={i} className="d-flex align-items-center gap-2 mb-2">
        <div>
          <AvatarComponent
            size={36}
            firstName={reactionUser?.by?.first_name}
            lastName={reactionUser?.by?.last_name}
            avatar={reactionUser?.by?.avatar}
            biggerAvatar
          />
        </div>
        <span className="font-weight-bold ">
          {reactionUser?.by?.first_name} {reactionUser?.by?.last_name}
        </span>
      </div>
    ))
  );

const EmojisCountModal = ({
  onCancel,
  visible,
  emojiData,
  postId,
  commentId,
  replyId,
  isDiscussion = false,
  isComment = false,
  isReplies = false,
}) => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(emojiData[0]?.reaction);

  const reactionPostData = useSelector(
    (state: any) => state?.roomReducer?.discussionReactionList?.reactionList
  );
  const reactionCommentData = useSelector(
    (state: any) => state?.roomReducer?.commentReactionList?.reactionList
  );
  const reactionRepliesData = useSelector(
    (state: any) => state?.roomReducer?.repliesReactionList?.reactionList
  );

  useEffect(() => {
    setActiveTab(emojiData[0]?.reaction);
  }, [emojiData]);

  useEffect(() => {
    isDiscussion &&
      dispatch(
        getDiscussionPostReactionList({
          reaction: emojiData[0]?.reaction,
          discussionId: postId,
        })
      );
    isComment &&
      dispatch(
        getCommentsReactionList({
          reaction: emojiData[0]?.reaction,
          commentId,
        })
      );
    isReplies &&
      dispatch(
        getRepliesReactionList({
          reaction: emojiData[0]?.reaction,
          replyId,
        })
      );
  }, [isDiscussion, isComment, isReplies]);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const tabArr = ['LIKE', 'DISLIKE', 'HEART_EYES'];

  return (
    <Modal visible={visible} onCancel={onCancel} maskClosable={false} footer={''}>
      <div className="emojis--tab__list">
        <Nav className="m-0">
          {emojiData?.map((el, i) => (
            <NavItem key={i}>
              <NavLink
                className={classnames({
                  active: activeTab === el?.reaction,
                })}
                onClick={() => {
                  isDiscussion &&
                    dispatch(
                      getDiscussionPostReactionList({
                        reaction: el?.reaction,
                        discussionId: postId,
                      })
                    );
                  isComment &&
                    dispatch(
                      getCommentsReactionList({
                        reaction: el?.reaction,
                        commentId,
                      })
                    );
                  isReplies &&
                    dispatch(
                      getRepliesReactionList({
                        reaction: el?.reaction,
                        replyId,
                      })
                    );
                  toggle(el?.reaction);
                }}
              >
                <span className="mr-1" style={{ fontSize: '20px' }}>
                  {emojis?.map((elm) => el?.reaction === elm?.title && elm?.value)}
                </span>
                {el?.reaction_count}
              </NavLink>
            </NavItem>
          ))}
        </Nav>
      </div>
      <div className="py-3">
        <TabContent activeTab={activeTab}>
          {tabArr?.map((el, i) => (
            <TabPane tabId={el} key={i}>
              {isDiscussion && ReactionListView(reactionPostData, postId)}
              {isComment && ReactionListView(reactionCommentData, commentId)}
              {isReplies && ReactionListView(reactionRepliesData, replyId)}
            </TabPane>
          ))}
        </TabContent>
      </div>
    </Modal>
  );
};

export default EmojisCountModal;
